import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../shared/services';

@Component({
  selector: 'app-payment-other-method-list',
  templateUrl: './payment-other-method-list.component.html',
  styleUrls: ['./payment-other-method-list.component.scss']
})
export class PaymentOtherMethodListComponent implements OnInit {

  @Input() otherOptionsConfig;
  @Input() config;
  DEFAUL_CONFIG = {
    list: {},
    wrapClass: '',
    selectPlaceHolder: 'Select'
  };
  @Output() dataEmit = new EventEmitter();

  qprams;

  constructor(
    private actRoute: ActivatedRoute,
    public util: UtilService
  ) { }

  ngOnInit(): void {
    this.otherOptionsConfig = { ...this.DEFAUL_CONFIG, ...this.otherOptionsConfig };
    this.actRoute.queryParams.subscribe(res => this.qprams = res);
  }

  showOtherOptions() {
    this.util.router.navigate([], { queryParams: { method_type: 'other' }, queryParamsHandling: 'merge' });
  }
}
